var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isSupportBrowser())?_c('el-alert',{staticStyle:{"position":"fixed","top":"30px","width":"300px"},attrs:{"type":"error","closable":false}},[_vm._v(" 请优先使用兼容该系统的浏览器，"),_c('a',{staticStyle:{"text-decoration":"underline"},attrs:{"target":"_Blank","href":"https://www.google.cn/intl/zh-CN/chrome/"}},[_vm._v("官方下载")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }